import { FETCH_ACTIVITY_LOG } from "../../actions/actionTypes";

const fetchLogsReducer = (logs, payload) => {

    let newLogs = { ...logs };
    if (payload.logs){
        for(let log of payload.logs){
            newLogs[log.logId] = log;
        }
    }
    return newLogs;
}



const logsReducer = (state={}, action) => {
    let logs = state;
    if (action && action.payload && !action.errors && !action.payload.errors){
        switch(action.type){
            case FETCH_ACTIVITY_LOG:
                return fetchLogsReducer(logs, action.payload);
            default:
                return logs;
        }
    }
    return logs;
}

export default logsReducer;